import { render, staticRenderFns } from "./KnFormSyllabus.vue?vue&type=template&id=b975e8e2"
import script from "./KnFormSyllabus.js?vue&type=script&lang=js&external"
export * from "./KnFormSyllabus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports